var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMrKobrosSittingOnAWall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 191,
    viewBox: "0 0 202 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201 123H1",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 117,
    width: 75,
    height: 8,
    fill: "#F7F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 165.329L93.1111 169.274C92.321 169.822 89.7926 170.589 86 169.274L86.2963 165",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 73.5244L142 74.7412L143.244 79L148.22 77.479C161.655 78.6958 161.904 72.916 160.349 69.8741L158.794 71.395C155.311 73.8286 151.745 72.409 150.397 71.395C151.019 65.9195 148.22 65.6153 148.22 66.2237V69.8741C147.971 71.0908 146.043 72.8146 145.11 73.5244Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.102 30.3905C112.489 32.1552 115.52 36.619 108.544 40.3561C107.091 44.8199 101.195 53.6851 89.236 53.436C84.7722 53.6436 74.9726 51.3183 71.4847 40.3561C69.0971 38.6952 65.5053 34.3767 70.239 30.3905",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.184 42.5361C99.4506 43.2835 94.1149 40.3561 92.0387 38.799L89.5473 40.6675L87.0559 38.799C83.0696 41.2904 77.0902 42.3285 74.5988 42.5361C80.3291 45.5258 86.9521 43.7818 89.5473 42.5361C96.2741 46.2732 102.108 44.0932 104.184 42.5361Z",
    fill: "#7205A3",
    stroke: "#7205A3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.364 25.7191H74.2875",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.603 22.7998C103.254 22.177 99.4335 20.9936 94.9489 21.2427",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2634 22.7998C77.6129 22.177 81.4331 20.9936 85.9176 21.2427",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7205 55.811L93.7033 63.5967L96.1947 56.7453L91.5233 53.3196M88.7205 55.811L83.7377 63.5967L81.2462 56.7453L85.9176 53.3196L88.7205 55.811Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5233 53.3196L88.7205 56.1224",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7204 62.9738L90.9004 59.8596L88.7204 56.1224L86.229 59.8596L88.7204 62.9738Z",
    fill: "#323232",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.34 33.0769V25.6027H91.8347C91.0873 34.8209 96.9214 36.7102 99.9318 36.5026C104.915 36.5026 107.614 34.2188 108.34 33.0769Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4608 33.0769V25.6027H88.9664C89.7138 34.8209 83.8798 36.7102 80.8693 36.5026C75.8865 36.5026 73.1875 34.2188 72.4608 33.0769Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.527 14.8191C114.524 11.3312 108.337 10.8744 105.119 11.082C107.112 -1.37502 94.7378 0.285922 88.3016 2.67352C77.0903 8.90205 68.2666 4.43827 65.2561 1.42782C64.5087 9.15119 68.8894 13.5734 71.1732 14.8191C69.1801 14.8191 70.3427 28.9371 71.1732 35.9961L73.6646 32.8819L75.2217 16.6877C82.1977 18.1825 90.7931 15.442 94.2187 13.8849C99.2016 11.6426 104.6 14.8191 106.676 16.6877V32.8819L109.167 34.7504L113.527 14.8191Z",
    fill: "#323232",
    stroke: "#323232",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.446 57H96.3248L92 111L101.576 108.503V76.6647C104.542 79.911 113.521 88.422 117.64 92.2717C126.784 89.2751 138.337 83.3237 142.971 80.7225C143.218 78.4751 141.838 75 141.117 73.5434L120.729 76.6647C119.74 71.1711 111.462 61.2659 107.446 57Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57L69.9467 59.1966C66.5957 65.2633 60.0763 79.1541 60.8074 86.1831C60.1981 94.9694 59.3451 113.923 60.8074 119.446C63.0415 119.864 67.997 120.45 69.9467 119.446C71.1653 110.241 73.2369 90.9528 71.7746 87.4383C73.6025 83.6727 77.2582 75.263 77.2582 71.7484",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9048 57L85 110.448C82.2143 110.864 75.7143 111.448 72 110.448",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101 108C111.944 109.782 134.265 115.107 136 122.151C135.897 127.706 132.221 142.654 118.345 158C116.487 157.581 112.088 155.925 109.363 152.654C112.357 145.212 118.841 129.509 120.823 126.239L101 122.151",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92 108H85",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4089 119C61.9195 120.778 61.4693 125.667 63.5833 131C65.1491 130.111 68.2221 127.667 67.9873 125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0619 119C69.7698 120.465 70.7609 124.4 69.0619 128.419L68 129.989C68 130.094 68 129.487 68 126.221",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.923 154L109 156.5C110.128 157.333 113.062 159 115.769 159L117 157.611",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.387 156C107.592 157.217 104 160.139 104 162.087C108.225 166.551 118.324 175.783 124.915 177C126.711 175.478 127.577 169.817 116.676 159.348",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5571 168.956C84.3524 170.749 82.1205 174.801 82.8311 176.663C88.3389 179.45 100.979 184.739 107.475 183.593C108.568 181.509 107.299 175.794 93.4705 169.604",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9504 115C97.1956 118.01 103.749 125.09 104 129.325C103.058 135.969 99.9802 152.495 95.2066 165.45C93.2176 165.865 88.4859 166.446 85.4711 165.45C85.6804 157.457 86.6645 139.291 88.9256 130.571C83.7961 129.325 72.0298 125.464 66 119.983",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrKobrosSittingOnAWall);
export default __webpack_public_path__ + "static/media/mr_kobros_sitting_on_a_wall.eade0c74761d72f25b7988c7d39c5f47.svg";
export { ForwardRef as ReactComponent };